module.exports = __webpack_public_path__ + "img/2-01-04-adp-physical-literacy.0b9797fd.svg";